import React, { useState } from "react";
import { Link } from "react-router-dom";
import coinIcon from "../assets/coin_icon.png";
import { Helmet } from "react-helmet";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Offcanvas,
  Dropdown,
  DropdownButton,
  ButtonGroup,
} from "react-bootstrap";

function AppNavbar() {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);
  const [aboutOpen, setAboutOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>JomFreeCredit - Free Online Credits Malaysia</title>
        <meta
          name="description"
          content="Get free credits online at JomFreeCredit. Trusted promotions and rewards in Malaysia."
        />
        <meta
          name="keywords"
          content="free credit, JomFreeCredit, online rewards, Malaysia, promotions"
        />
        <meta name="author" content="JomFreeCredit" />

        {/* Open Graph for Facebook */}
        <meta
          property="og:title"
          content="JomFreeCredit - Free Online Credits Malaysia"
        />
        <meta
          property="og:description"
          content="Discover free online credits and rewards with JomFreeCredit in Malaysia."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://jomfreecredit.online" />
        <meta
          property="og:image"
          content="https://jomfreecredit.online/images/og-image.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="JomFreeCredit - Free Online Credits Malaysia"
        />
        <meta
          name="twitter:description"
          content="Get free online credits and rewards with JomFreeCredit."
        />
        <meta
          name="twitter:image"
          content="https://jomfreecredit.online/images/twitter-card.jpg"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://jomfreecredit.online" />
      </Helmet>
      <Navbar
        bg="light"
        expand="lg"
        className="navbar-wrapper"
        rel="noopener noreferrer sponsored"
      >
        <Container>
          {/* Brand */}
          <Navbar.Brand as={Link} to="/" className="m-3">
            <img
              src={coinIcon}
              width="40"
              height="40"
              className="me-2"
              alt="Coin Icon"
              rel="noopener noreferrer sponsored"
            />
            <span className="navbar-logo-text-span">
              Free Credit {new Date().getFullYear()}
            </span>
          </Navbar.Brand>

          {/* Mobile toggle button */}
          <Button className="d-lg-none nav-hamburger-btn" onClick={handleShow}>
            Menu ☰
          </Button>

          {/* Desktop nav links */}
          <Nav className="ms-auto d-none d-lg-flex">
            <Button as={Link} to="/">
              Home
            </Button>
            <div className="vr"></div>
            <Button variant="secondary">Free Credit List</Button>
            <div className="vr"></div>
            <DropdownButton
              id="dropdown-basic-button"
              title="About Us"
              variant="secondary"
            >
              <Dropdown.Item as={Link} to="/aboutus">
                About Us
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/casinoreview">
                Casino Review Criteria
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/editorial">
                Editorial Policy
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/privacypolicy">
                Privacy Policy
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/responsiblegaming">
                Responsible-Gaming
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/contactus">
                Contact Us
              </Dropdown.Item>
            </DropdownButton>
          </Nav>
        </Container>
      </Navbar>

      {/* Sidebar for mobile */}
      <Offcanvas
        show={showSidebar}
        onHide={handleClose}
        placement="start"
        className="nav-offcanvas-container"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ButtonGroup vertical className="w-100">
            <Button
              variant="secondary"
              className="d-flex"
              as={Link}
              to="/"
              onClick={handleClose}
            >
              Home
            </Button>
            <Button
              variant="secondary"
              className="d-flex"
              onClick={handleClose}
            >
              Free Credit List
            </Button>

            {/* Expand/Collapse Parent */}
            <Button
              variant="secondary"
              onClick={() => setAboutOpen(!aboutOpen)}
              className="d-flex align-items-center justify-content-between"
            >
              About Us
              <span style={{ fontSize: "0.8em" }}>{aboutOpen ? "▲" : "▼"}</span>
            </Button>

            {/* Collapsible Items */}
            {aboutOpen && (
              <div className="sidebar-collapse-items">
                <Button
                  variant="secondary"
                  as={Link}
                  to="/aboutus"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  About Us
                </Button>
                <Button
                  variant="secondary"
                  as={Link}
                  to="/casinoreview"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Casino Review Criteria
                </Button>
                <Button
                  variant="secondary"
                  as={Link}
                  to="/editorial"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Editorial Policy
                </Button>
                <Button
                  variant="secondary"
                  as={Link}
                  to="/privacypolicy"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Privacy Policy
                </Button>
                <Button
                  variant="secondary"
                  as={Link}
                  to="/responsiblegaming"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Responsible-Gaming
                </Button>
                <Button
                  variant="secondary"
                  as={Link}
                  to="/contactus"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Contact Us
                </Button>
              </div>
            )}
          </ButtonGroup>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AppNavbar;
